<template>
  <div data-cy="overview-container">
    <material-overview-partner-view v-if="isPartnerView" />
    <material-overview-client-view v-else />
  </div>
</template>

<script>
import { ROLE_ADMIN, ROLE_NAME, MY_VIEW_PATH_SEGMENT } from '../constants/app'
export default {
  computed: {
    isPartnerView () {
      return (
        localStorage.getItem(ROLE_NAME) === ROLE_ADMIN &&
                this.$route.params.clientId === MY_VIEW_PATH_SEGMENT
      )
    }
  }
}
</script>
